import { WebIcon } from './WebIcon';

/**
 * author: Google
 * id DA9C32CA-8C31-4462-B123-479169C31587
 * name web
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/web.svg
 * tags
 * - Geographic Information System 
 */
export const WorldWideWebIcon = WebIcon;
export default WorldWideWebIcon